import { Route, Routes as RoutesContainer } from "react-router";
import { Age, Create, Edit } from "../index";

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/age' element={<Age />} />
      <Route exact path='/age/create' element={<Create />} />
      <Route exact path='/age/edit/:id' element={<Edit />} />
    </RoutesContainer>
  );
};
export default Routes;
